import { Component, ViewEncapsulation } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { StorageService } from 'src/app/Core/_services/storage/storage.service';
import { ToastService } from 'src/app/Shared/services/toast/toast.service';
import { emailValidator } from 'src/app/_utlis/app-validators';
import { BuyerAuthService } from '../../services/buyer-auth/buyer-auth.service';
import { DefulatRouting } from 'src/app/_utlis/enums/defualt-routing.enum';
import { Meta, Title } from '@angular/platform-browser';
import { PreviousRouteService } from 'src/app/Shared/services/previous-route/previous-route.service';
import { environment } from 'src/environments/environment';
// import { NavigateToLanding } from 'src/app/_utlis/navigateToLanding';

import {
  isEmpty} from 'src/app/_utlis/language/language-helper';
import { CommonModule, Location, NgClass } from '@angular/common';
import { AnalyticsService } from 'src/app/Shared/_services/analytics/analytics.service';
import { getQueryString } from 'src/app/_utlis/convert-url';
import { LogoComponent } from '../../../../../../Shared/components/logo/logo.component';
import { LanguageSwitcherComponent } from '../../../../../../Shared/components/language-switcher/language-switcher.component';
import { MatIcon } from '@angular/material/icon';
import {
  MatFormField,
  MatError,
  MatSuffix,
} from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatIconButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { TranslatePipe } from '@ngx-translate/core';
import { Navigation } from 'src/app/_utlis/navigateToLanding';
import { Breadcrumb } from 'src/app/Shared/_models/breadcrumb.model';
import { BreadCrumbsComponent } from 'src/app/Shared/components/bread-crumbs/bread-crumbs.component';
import { PusherService } from 'src/app/Shared/services/pusher/pusher.service';

@Component({
    selector: 'app-buyer-login',
        standalone: true,
templateUrl: './buyer-new-login.component.html',
    styleUrls: ['./buyer-new-login.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [
    ReactiveFormsModule,
    RouterLink,
    NgClass,
    BreadCrumbsComponent,
    CommonModule,
    TranslatePipe
]
})
export class BuyerLoginComponent {
  formData!: FormGroup;
  // buyerDefualtPath = DefulatRouting.BUYER;
  buyerDefualtPath = environment.wordpressUrl;
  submit_clicked!: boolean;navTranslation!: any;
  showPassword: boolean = false;
  breadcrumbItems: Breadcrumb[] = [];
  constructor(
    private fb: FormBuilder,
    private auth: BuyerAuthService,
    private storage: StorageService,
    private toastService: ToastService,
    private router: Router,
    private titleService: Title,
    private previousRouteService: PreviousRouteService,
    private _location: Location,
    private analyticsService: AnalyticsService,
    private meta: Meta,
    private nav: Navigation,
    private pusherService: PusherService
  ) {
    this.titleService.setTitle('Login to Your Account |BidxSell');
    this.meta.addTag({
      name: 'description',
      content:
        'Access your bidxsell account to bid on horses, manage your purchases, and stay updated on auction results.',
    });
    this.initForm();
  }
  ngOnInit(): void {
    if (this.auth.isLoggedIn()) {
      const userData = this.storage.userData;
      if (userData && userData.is_buyer && userData.email_verified_at) {
        this.nav.NavigateToLanding();
      }
    }
  }

  initForm() {
    this.formData = this.fb.group({
      email: new FormControl(
        '',
        Validators.compose([Validators.required, emailValidator])
      ),
      password: new FormControl('', Validators.compose([Validators.required])),
    });
  }

  onSubmit() {
    this.toastService.clear();
    if (this.formData.valid) {
      this.submit_clicked = true;
      this.auth.login(this.formData.value).subscribe({
        next: (response: { data: { token: string; user: any } }) => {
          const { user, token } = response.data;

          if (!user.email_verified_at) {
            this.router.navigate(['/buyer/auth/verify-email'], {
              queryParams: { email: user.email },
            });
          } else {
            this.storage.userToken = token;
            this.storage.userData = JSON.stringify(user);
            this.auth.setLoggedIn_authorized(true);
            this.pusherService.updateAuthToken(token);
            const previousUrl = this.previousRouteService.getPreviousUrl();

            if (previousUrl && previousUrl?.includes('/buyer/')) {
              const { path, queryObject } = getQueryString(previousUrl);
              this.router.navigate([path], {
                queryParams: queryObject,
              });
            } else {
              this.nav.NavigateToLanding();
            }
          }
          // Track successful login
          // this.analyticsService.trackLogin(true);
          this.submit_clicked = false;
        },
        error: (error) => {
          this.submit_clicked = false;
          // Track failed login
          // this.analyticsService.trackLogin(false, error?.error?.Error?.[0] || 'unknown');
          // BXS-3586: the error toast is shown globally by ResponseCheckInterceptor
          // (HTTP 422). Component-level toast removed to stop the duplicate message.
        },
      });
    }
  }
  back() {
    this._location.back();

    // const previousUrl = this.previousRouteService.getPreviousUrl();
    // if (previousUrl) {
    //   const { path, queryObject } = getQueryString(previousUrl);
    //   this.router.navigate([path], {
    //     queryParams: queryObject,
    //   });
    // } else {
    //   this._location.back();
    // }
  }
  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }
}
